import { useEffect, useRef, useState } from 'react';
import { Banner, BlockStack, Page, Text } from '@shopify/polaris';
import { useNavigate } from 'react-router-dom';
import agent from '../../app/api/agent';
import { useStore } from '../../app/stores/store';
import { getShopifyAuthFromSearch } from '../../app/utils/shopifyAuth';

export default function OriginalAppEntryPage() {
  const { userStore } = useStore();
  const navigate = useNavigate();
  const started = useRef(false);
  const [error, setError] = useState('');
  const [legacyUrl, setLegacyUrl] = useState('');
  useEffect(() => {
    if (started.current) return;
    started.current = true;
    userStore.logout();
    const open = async () => {
      const shop = new URLSearchParams(window.location.search).get('shop') || '';
      if (!/^[a-z0-9][a-z0-9-]*\.myshopify\.com$/.test(shop)) throw new Error('Invalid store');
      const idToken = await window.shopify?.idToken?.();
      if (!idToken) throw new Error('Shopify session unavailable');
      const route = await agent.Account.resolveOriginalApp(shop, idToken);
      if (route.owner === 'PFV1') {
        const expected = 'https://car.govedia.com/Login?shop=' + encodeURIComponent(shop);
        if (route.legacyUrl !== expected) throw new Error('Invalid destination');
        setLegacyUrl(expected);
        window.open(expected, '_top');
      } else if (route.owner === 'PFV2') {
        await userStore.embeddedLogin({ ...getShopifyAuthFromSearch(''), shop, id_token: idToken, embedded: '1' });
        navigate('/dashboard', { replace: true });
      } else throw new Error('Unknown destination');
    };
    void open().catch(() => setError('We could not confirm your app installation. Reopen the app from Shopify admin, or contact support.'));
  }, [navigate, userStore]);
  return <Page title="Opening PartFinder"><BlockStack gap="400">
    {error ? <Banner tone="critical">{error}</Banner> : <Text as="p">Opening your store’s app…</Text>}
    {legacyUrl && <a href={legacyUrl} target="_top">Continue to PartFinder</a>}
  </BlockStack></Page>;
}
